module.exports = __webpack_public_path__ + "img/yan5.dcc09987.png";